export const messageTypes = {
  "ActiveCollab\\Module\\System\\Model\\Message\\UserMessage": "UserMessage",
  "ActiveCollab\\Module\\System\\Model\\Message\\UserRemovedConversationMessage": "UserRemovedConversationMessage",
  "ActiveCollab\\Module\\System\\Model\\Message\\UserLeftConversationMessage": "UserLeftConversationMessage",
  "ActiveCollab\\Module\\System\\Model\\Message\\UserRenamedConversationMessage": "UserRenamedConversationMessage",
  "ActiveCollab\\Module\\System\\Model\\Message\\UserInvitedConversationMessage": "UserInvitedConversationMessage",
};
